import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcesses(organization_id) {
    return RequesterV1.get(`organization/reporting/process/list_processes/${organization_id}`);
  }
};
